<template>
  <div class="home">
    <div class="login-box">
      <!-- :style="{
        width: `${loginWidth}px`,
        'margin-left': `${loginMarginLeft}px`,
      }" -->
      <div class="banner">
        <el-carousel  type="dots" class="top_bg" height="100%" arrow="never">
          <el-carousel-item v-for="(item, idx) in imageList" :key="idx">
            <el-image style="height: 100%; width: 100%" :src="item.img" fit="cover" @click="bannerJump(item)"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!--  -->
      <div
        v-if="!isLogin"
        class="login"
        >
        <!-- :style="{
          right: `${0 - loginMarginLeft}px`,
        }" -->
        <p class="hint">验证码登录</p>
        <el-input class="input-phone" placeholder="请输入手机号" v-model="phone">
          <template slot="prepend">+86</template>
        </el-input>
        <el-input class="input-vcode" placeholder="请输入验证码" v-model="vcode">
          <el-button slot="append" @click="sendVcode()">{{ text }}</el-button>
        </el-input>
        <div class="check-line">
          <!-- <el-checkbox v-model="autoLogin">下次自动登录</el-checkbox> -->
        </div>
        <el-button class="login-btn" type="primary" round @click="loginClick">登录</el-button>
        <div class="check-rule">
          <el-checkbox v-model="checkRule">
            <span class="text">阅读并同意<span @click.stop="yinsi2">服务协议 、</span><span @click.stop="yinsi">隐私政策</span></span>
          </el-checkbox>
        </div>
        <div class="wx-line" @click="goWxLogin">
          <img src="@/assets/images/icon-wechat.png" alt="" />
          <span>微信登录</span>
        </div>
      </div>
    </div>
    
    <div class="ai-banner-wrapper" @click="handleAiBannerClick">
      <div class="ai-banner-content">
        <div class="ai-btn">
          AI快速诊股 <i class="el-icon-right"></i>
        </div>
        <div class="ai-desc">就用皂富鹅AI大模型技术诊股</div>
      </div>
    </div>

    <div class="preview-box" ref="page">
      <div
        class="preview-column"
        ref="column1"
        :style="{
          width: `${columnWidth[0]}px`,
        }">
        <div class="mod-box box1">
          <div class="mod-title">
            <span>学习打卡-快速入门</span>
          </div>
          <div class="ctx-wrap h-study">
            <div class="list-wrap">
              <Waterfall :list="studyList" :width="columnWidth[0] / 2" :gutter="0" :hasAroundGutter="false" :breakpoints="waterfallBreakpoints">
                <template #item="{ item, index }">
                  <div
                    class="study-item"
                    :style="{
                      width: `${columnWidth[0] / 2}px`,
                    }">
                    <div class="desc-box">
                      <img :src="item.image || defaultCover" alt="" />
                      <div class="text">
                        <div class="main-text">{{ item.name }}</div>
                        <div class="sub-text">{{ item.remark }}</div>
                      </div>
                    </div>
                    <ul class="article-list">
                      <li v-for="(d, i) in (item.details || []).slice(0, 3)" :key="`${index}_${i}`">
                        <span class="title">{{ d.name }}</span>
                        <span class="status">{{ ["未开始", "学习中", "已完成"][d.status + 1] }}</span>
                      </li>
                    </ul>
                  </div>
                </template>
              </Waterfall>
            </div>
            <div class="mod-mask" @click="toLogin">
              <div class="red-text" v-if="!isLogin">加入皂富鹅</div>
              <div class="red-text" v-else>查看更多</div>
              <div class="grey-text">开始我的学习打卡计划</div>
            </div>
          </div>
        </div>
        <div class="mod-box box2">
          <div class="mod-title">
            <span>投资问答-<span>皂富鹅专业团队为你解答</span></span>
          </div>
          <div class="ctx-wrap">
            <div class="list-wrap">
              <ul class="qa-list">
                <li class="qa-item" v-for="(item, index) in qaList" :key="index">
                  <div class="qa-question">
                    <!-- <img src="" alt=""> -->
                    <div class="val">Q：{{ item.question }}</div>
                  </div>
                  <div class="qa-answer">
                    <img src="@/assets/images/discussion/admin.png" alt="" />
                    <div class="val" v-html="`A：${item.answer}`" @click="prevImg"></div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        class="preview-column"
        :style="{
          width: `${columnWidth[1]}px`,
        }">
        <div class="mod-box box3">
          <div class="mod-title">
            <span>最新专栏</span>
          </div>
          <div class="ctx-wrap h-course">
            <div class="list-wrap">
              <ul class="course-list">
                <li class="course-item" v-for="(item, index) in courseList" :key="index">
                  <img :src="item.img" alt="" />
                  <div class="info-wrap">
                    <div class="title-wrap">
                      <div class="title">{{ item.name }}</div>
                      <div class="sub-title">{{ item.descd }}</div>
                    </div>
                    <div class="count">
                      <span class="tiao">{{ item.detailNum }}条知识</span>
                      <span class="status"></span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="mod-mask" @click="toLogin">
              <div class="red-text" v-if="!isLogin">加入皂富鹅</div>
              <div class="red-text" v-else>查看更多</div>
              <div class="grey-text">获取更多专栏信息</div>
            </div>
          </div>
        </div>
        <div class="mod-box box4">
          <div class="mod-title">
            <span>皂富鹅聊天室</span>
          </div>
          <div class="ctx-wrap h-chat">
            <div class="list-wrap">
              <ul class="chatroom-list">
                <li class="chatroom-item" v-for="(item, index) in chatroomList" :key="index">
                  <div class="top-wrap">
                    <img :src="item.avatar" alt="" />
                    <div class="info-wrap">
                      <div class="name">{{ item.name }}</div>
                      <div class="join-btn">加入聊天室</div>
                    </div>
                  </div>
                  <div class="desc">周期女王：简单讲尾盘：如图，早盘已讲过了。你有三个选择。1.尾盘出手但下一生个股</div>
                </li>
              </ul>
            </div>
            <div class="mod-mask" @click="toLogin">
              <div class="red-text" v-if="!isLogin">加入皂富鹅</div>
              <div class="red-text" v-else>查看更多</div>
              <div class="grey-text">获取更多聊天室信息</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible="showInvitePage" :show-close="true" width="352px" :center="true" :append-to-body="true" custom-class="invite-dialog" @close="handleClose">
      <div class="top-wrap">
        <img src="@/assets/images/web-logo.png" alt="" />
        <div class="text-wrap">
          <span class="name">皂富鹅</span>
          <span class="name2">独树一帜 只为梦想</span>
        </div>
      </div>
      <div class="name3">
        <span>皂富鹅属于邀请制访问</span>
        <span>请联系管理员获取邀请码</span>
      </div>
      <div class="name4">
        <span>每日市场情报</span>
        <span>与高手畅聊投资</span>
      </div>
      <input type="text" placeholder="请输入邀请码" v-model="inviteCode" />
      <el-button class="login-btn" type="primary" @click="onLoginClick">确认</el-button>
      <span class="contact-btn" @click="contactAdmin">联系管理员</span>
    </el-dialog>
    <!-- <el-dialog :visible="showQrcodeDialog" :show-close="true" width="352px" :center="true" :append-to-body="true" custom-class="invite-dialog" @close="onQrcodeDialogClose">
      <div class="top-wrap">
        <img src="@/assets/images/web-logo.png" alt="" />
        <div class="text-wrap">
          <span class="name">皂富鹅</span>
          <span class="name2">独树一帜 只为梦想</span>
        </div>
      </div>
      <div class="name3">
        <span>登录成功</span>
        <span>扫码加入皂富鹅投资交流群</span>
      </div>
      <div class="name4">
        <span>每日市场情报</span>
        <span>与高手畅聊投资</span>
      </div>
      <div class="qrcode-box">
        <img :src="qrcode" alt="" />
      </div>
      <span class="hint">微信扫一扫 立即进群</span>
    </el-dialog> -->
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="contentPic" :z-index="9999" />

    <el-dialog :visible="showPhoneBind" width="352px" :center="true" :append-to-body="true" :show-close="false" custom-class="pb-dialog">
      <div class="login">
        <p class="hint">绑定手机号</p>
        <p class="hint-span">使用第三方登录的用户需绑定手机号</p>
        <el-input class="input-phone" placeholder="请输入手机号" v-model="phone">
          <template slot="prepend">+86</template>
        </el-input>
        <el-input class="input-vcode" placeholder="请输入验证码" v-model="vcode">
          <el-button slot="append" @click="sendVcode('bind')">{{ text }}</el-button>
        </el-input>
        <div class="check-line">
          <!-- <el-checkbox v-model="autoLogin">下次自动登录</el-checkbox> -->
        </div>
        <el-button class="login-btn" type="primary" round @click="bindClick()">绑定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible="showLogin" width="352px" :center="true" :append-to-body="true" custom-class="pb-dialog" @close="handleClose">
      <div class="login">
        <p class="hint">验证码登录</p>
        <!-- <p class="hint-span">使用第三方登录的用户需绑定手机号</p> -->
        <el-input class="input-phone" placeholder="请输入手机号" v-model="phone">
          <template slot="prepend">+86</template>
        </el-input>
        <el-input class="input-vcode" placeholder="请输入验证码" v-model="vcode">
          <el-button slot="append" @click="sendVcode('login')">{{ text }}</el-button>
        </el-input>
        <div class="check-line">
          <!-- <el-checkbox v-model="autoLogin">下次自动登录</el-checkbox> -->
        </div>
        <el-button class="login-btn" type="primary" round @click="loginClick">登录</el-button>
        <div class="check-rule">
          <el-checkbox v-model="checkRule">
            <span class="text">阅读并同意<span @click.stop="yinsi2">服务协议 、</span><span @click.stop="yinsi">隐私政策</span></span>
          </el-checkbox>
        </div>
        <div class="wx-line" @click="goWxLogin">
          <img src="@/assets/images/icon-wechat.png" alt="" />
          <span>微信登录</span>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible="showadmin" :show-close="true" width="352px" :center="true" :append-to-body="true" custom-class="pb-dialog" @close="handleClose">
      <div class="admin">
        <div class="line1">
          <img src="@/assets/images/icon-wechat.png" alt="" />
          <div>使用微信扫一扫</div>
        </div>
        <div class="line2">「联系管理员」</div>
        <div class="line3">
          <img :src="qrcode" alt="" />
        </div>
      </div>
    </el-dialog>

    <transition @scrollin="checkBottom"></transition>
  </div>
</template>

<script>
import sendVerifyCode from "@/mixins/SendVerifyCode";
import { registerVerify, loginMobile, getUserInfo, getCodeUrl } from "@/api/user";
import { bindInviteCode, getConfig, wxpcBindPhone } from "@/api/user.js";
import { LOGIN_TOKEN_KEY, LOGIN_USER_INFO } from "@/utils/constants";
import { mapMutations } from "vuex";
import { getModuleListPC, getModuleList, getStudyCourseList } from "@/api/study.js";
import { getList, validateColumnCode } from "@/api/course.js";
import { getQaList } from "@/api/qa.js";
import { getChatroomList, getChatroomListPC } from "@/api/chatroom";
import VueMasonry from "vue-masonry-css";
import { LazyImg, Waterfall } from "vue-waterfall-plugin";
import "vue-waterfall-plugin/dist/style.css";
import { getBanner } from "@/api/notes";
import transition from "@/components/transition.vue";
import { mapState } from "vuex";

export default {
  name: "HomeView",
  mixins: [sendVerifyCode],
  components: {
    VueMasonry,
    Waterfall,
    LazyImg,
    transition,
  },
  data() {
    return {
      phone: "",
      vcode: "",
      autoLogin: false,
      checkRule: false,
      studyList: [],
      studyWidth: 0,
      courseList: [],
      qaList: [],
      chatroomList: [],
      // isLogin: localStorage.getItem(LOGIN_TOKEN_KEY),
      columnWidth: [0, 0],
      waterfallBreakpoints: {
        1200: { rowPerView: 2 },
        800: { rowPerView: 2 },
        500: { rowPerView: 2 },
      },
      showInvitePage: false,
      inviteCode: "",
      qrcode: "",
      showQrcodeDialog: false,
      qrUrl: "",
      defaultCover: require("@/assets/images/study-cover.png"),
      contentPic: [],
      showViewer: false,
      loginWidth: 1440,
      loginMarginLeft: 0,
      showPhoneBind: false,
      imageList: ["../../assets/images/clockin-bg.png", "../../assets/images/clockin-bg.png", "../../assets/images/clockin-bg.png"],
      src: require("../assets/images/clockin-bg.png"),
      showLogin: false,
      pageQa: 1,
      showadmin: false,
    };
  },
  computed: {
    ...mapState(["isLogin"]), // 映射 isLogin 到计算属性
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    checkBottom(e) {
      const { scrollTop, clientHeight, scrollHeight } = e;
      if (scrollTop + clientHeight >= scrollHeight - 100 && !this.isLoading) {
        this.pageQa++;
        this.getQaList();
      }
    },
    bannerJump(item) {
      const url = item.link || null;
      if (url) {
        if (item.linktype == 1) {
          console.log("jump1", url);
          if (url.startsWith("/")) {
            //内页
            this.$router.push(url);
          }
        } else {
          //外页
          console.log("jump2", url);
          if (url.startsWith("http")) {
            window.open(url, "_blank");
          }
        }
      }
    },
    bindClick() {
      wxpcBindPhone({ phone: this.phone, captcha: this.vcode })
        .then((res) => {
          console.log("绑定手机号", res);
          if (res && res.success) {
            if (!res.data) {
              this.$message.success(res.msg);
              localStorage.removeItem(this.$constants.LOGIN_TOKEN_KEY);
              localStorage.removeItem(this.$constants.LOGIN_USER_INFO);
              this.$store.dispatch("logout");
              setTimeout(() => {
                location.reload();
              }, 3000);
              return;
            }
            this.getUserDetail();
            this.showPhoneBind = false;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err.msg || err.response.data.msg || err.response.data.message);
        });
    },
    // 加入提示
    toLogin() {
      // let result = localStorage.getItem(LOGIN_USER_INFO);
      // let result2 = JSON.parse(result);
      // if (!result2) {
      //   // this.showPhoneBind=true
      //   // this.$message("请先登录");
      //   this.showLogin = true;
      // }
      this.getUserDetail();
    },
    handleClose() {
      this.showInvitePage = false;
      this.showLogin = false;
      this.showadmin = false;
    },
    prevImg(e) {
      if (e.target.nodeName == "IMG" || e.target.nodeName == "img") {
        const img = e.target.currentSrc;
        this.onPreview([img]);
      }
    },
    yinsi() {
      const baseUrl = `${window.location.origin}${window.location.pathname}`;
      console.log("window.location", baseUrl);
      // this.$router.push("/stock");
      // window.open('http://localhost:8080/#/stock')
      const targetUrl = `${baseUrl}#/userPrivacy2`;
      window.open(targetUrl, "_blank", "noopener,noreferrer");
      // this.$router.push("/userPrivacy2");
    },
    yinsi2() {
      const baseUrl = `${window.location.origin}${window.location.pathname}`;
      console.log("window.location", baseUrl);
      // this.$router.push("/stock");
      // window.open('http://localhost:8080/#/stock')
      const targetUrl = `${baseUrl}#/userPrivacy3`;
      window.open(targetUrl, "_blank", "noopener,noreferrer");
      // this.$router.push("/userPrivacy3");
    },
    onPreview(img) {
      this.contentPic = img;
      this.showViewer = true;
    },
    closeViewer() {
      this.contentPic = [];
      this.showViewer = false;
    },
    getCodeUrl() {
      getCodeUrl({ route: `#/wxlogin` }).then((res) => {
        console.log("二维码链接", res);
        if (res && res.success) {
          this.qrUrl = res.data.qrUrl;
        }
      });
    },
    onLoginClick() {
      if (!this.inviteCode) {
        return this.$message({
          message: "输入邀请码",
          type: "warning",
        });
      }
      bindInviteCode({
        code: this.inviteCode,
        login: true,
      })
        .then((res) => {
          if (res && res.success) {
            console.log("绑定邀请码成功", res);
            this.getUserDetail();

            this.showInvitePage = false;
            // this.showQrcodeDialog = true;

            this.onQrcodeDialogClose();
          } else {
            console.log("绑定邀请码失败", res);
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log("绑定邀请码失败2", err);
          this.$message({
            message: err.msg || err.response.data.msg || err.response.data.message,
            type: "error",
          });
        });
    },
    contactAdmin() {
      // this.showQrcodeDialog = true;
      // this.onQrcodeDialogClose();
      this.showadmin = true;
    },
    async getQrcode() {
      getConfig({
        name: "config_admin_qr",
      })
        .then((res) => {
          if (res && res.success) {
            this.qrcode = res.data;
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: err.msg || err.response.data.msg || err.response.data.message,
            type: "error",
          });
        });
    },
    onQrcodeDialogClose() {
      this.showQrcodeDialog = false;
      if (!this.showInvitePage) {
        this.$router.push("/in/clockin");
      }
    },
    calcSize() {
      let previewWidth = this.$refs.page.offsetWidth;
      let w1 = 736,
        w2 = 352;
      let w = previewWidth - 0;
      this.columnWidth = [(w * w1) / (w1 + w2), (w * w2) / (w1 + w2)];
      let width = document.documentElement.clientWidth;
      if (width < 1440) {
        width = 1440;
      }
      let offset = width - 1120;
      if (offset < 0) {
        offset = 0;
      }
      this.loginWidth = width;
      this.loginMarginLeft = 0 - offset / 2;
      console.log("数据数据", this.loginMarginLeft);
    },
    sendVcode(type) {
      if (!this.phone) {
        return this.$message({
          message: "请输入手机号",
          type: "warning",
        });
      }
      if(this.disabled){
        return
      }
      registerVerify({ phone: this.phone, type })
        .then((res) => {
          this.$message.success("验证码发送成功，请注意查收");
          this.sendCode();
        })
        .catch((err) => {
          console.log("发送验证码报错", err);
          this.$message.error(err.msg || "发送验证码异常");
          // this.vcode = err.msg.slice(err.msg.length - 6);
          // this.sendCode();
        });
    },
    loginClick() {
      if (!this.checkRule) {
        this.$message({
          message: "请勾选阅读并同意“服务协议”和“隐私政策”以继续登录",
          type: "warning",
        });
        return;
      }
      loginMobile({
        account: this.phone,
        captcha: this.vcode,
      })
        .then((res) => {
          console.log("登录结果", res);
          if (res && res.success) {
            localStorage.setItem(LOGIN_TOKEN_KEY, res.data.token);
            this.$store.dispatch("login", { token: res.data.token });

            // this.isLogin = true;
            this.getUserDetail();
            // this.$router.push('/in/clockin');
          }
        })
        .catch((err) => {
          this.$message.error(err.msg);
          console.log("登录报错", err);
        });
    },
    getUserDetail() {
      getUserInfo()
        .then((res) => {
          console.log("用户信息", res);
          if (res && res.success) {
            if (!res.data.phone || res.data.phone == "") {
              this.showPhoneBind = true;
              return;
            }

            // setUserInfo(res.data);
            // localStorage.setItem(LOGIN_USER_INFO, JSON.stringify(res.data));
            this.$store.dispatch("login", { userinfo: res.data });
            localStorage.setItem(LOGIN_USER_INFO, JSON.stringify(res.data));

            // this.showQrcodeDialog = true;
            this.onQrcodeDialogClose();
          }
        })
        .catch((err) => {
          if (err && err.data.status == 401) {
            this.showLogin = true;
          }
          if (err && err.data.status == 5107) {
            this.showPhoneBind = true;
          }
          if (err && err.data.status == 5106) {
            this.showInvitePage = true;
          }
          console.log("获取用户信息失败", err);
        });
    },
    goWxLogin() {
      if (this.qrUrl) {
        window.location = this.qrUrl;
      }
      // this.$router.push('/wxlogin');
    },
    handleAiBannerClick() {
      if (this.isLogin) {
        this.$router.push('/aichat');
      } else {
        this.showLogin = true;
      }
    },
    getAllData() {
      this.getStudyData();
      this.getCourseList();
      this.getQaList();
      this.getChatList();
    },
    getStudyData() {
      getModuleListPC({
        page: 1,
        limit: 4,
      }).then((res) => {
        if (res && res.success) {
          this.studyList = res.data;
        }
      });
    },
    getStudyDetailData(index, id) {
      getStudyCourseList({
        page: 1,
        limit: 4,
        studyId: id,
      }).then((res) => {
        if (res && res.success) {
          this.$set(this.studyList, index, {
            ...this.studyList[index],
            list: res.data,
          });
        }
      });
    },
    getCourseList() {
      getList({
        page: 1,
        limit: 3,
      }).then((res) => {
        console.log("最新专栏最新专栏", res);

        if (res && res.success) {
          this.courseList = res.data;
        }
      });
    },
    getQaList() {
      getQaList({
        page: this.pageQa,
        limit: 10,
        isRelease: 1,
      }).then((res) => {
        if (res && res.success) {
          let newItems = res.data || [];
          this.qaList = [...this.qaList, ...newItems];
        }
      });
    },
    getChatList() {
      getChatroomListPC({
        page: 1,
        limit: 4,
      }).then((res) => {
        if (res && res.success) {
          this.chatroomList = res.data;
        }
      });
    },
    getBannerList() {
      getBanner({ type: "pcHome" }).then((res) => {
        if (res.data) {
          // this.imageList = res.data || [];
          let imgs = res.data || [];
          if (imgs.length > 1) {
            this.imageList = [...imgs, ...imgs];
          } else {
            this.imageList = imgs;
          }
        }
      });
    },
    init() {
      this.getBannerList();
      // 10分钟轮询
      this.getCodeUrl();
      setTimeout(() => {
        this.getCodeUrl();
      }, 1000 * 60 * 10);
      this.getQrcode();
      this.getAllData();
    },
  },
  mounted() {
    this.init();

    let pathParams = this.$route.query;

    if (pathParams.qrLogin == 1) {
      this.getUserDetail();
    } else if (this.isLogin) {
      // this.$router.push("/in/clockin");
      this.getUserDetail();
    }

    window.addEventListener("resize", this.calcSize);
    this.$nextTick(() => {
      this.studyWidth = this.$refs.column1.offsetWidth / 2;
      this.calcSize();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcSize);
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__headerbtn {
  top: -30px !important;
  right: 0 !important;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background: rgba(#000000, 0.2);
}
.login-box {
  height: 468px;
  position: relative;
  // background: red;

  .banner {
    width: 100vw;
    height: 468px;
    // background: url("~@/assets/images/home-cover.png") no-repeat center center;
    // background-size: auto 100%;
    // height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    .top_bg {
      width: 100%;
      height: 100%;
    }
  }

  .login {
    width: 352px;
    height: 388px;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    padding: 24px;
    z-index: 10;
    box-sizing: border-box;

    .hint {
      font-weight: bold;
    }

    .input-phone {
      height: 48px;
      background: #f1f2f5;
      margin-top: 24px;
      border-radius: 4px;

      ::v-deep .el-input-group__prepend {
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        background: #f1f2f5;
        border: none;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 27px;
          right: 0px;
          background: rgba(0, 0, 0, 0.2);
        }
      }

      ::v-deep input {
        height: 100%;
        background: #f1f2f5;
        border: none;
      }
    }

    .input-vcode {
      height: 48px;
      background: #f1f2f5;
      margin-top: 16px;
      border-radius: 4px;

      ::v-deep input {
        height: 100%;
        background: #f1f2f5;
        border: none;
      }

      ::v-deep .el-input-group__append {
        background: #f1f2f5;
        border: none;
      }
    }

    .check-line {
      margin-top: 16px;

      ::v-deep .el-checkbox__label {
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.4);
      }

      ::v-deep .el-checkbox__inner {
        border-radius: 50%;
        width: 20px;
        height: 20px;
        border-radius: 4px;

        &::after {
          left: 7px;
          top: 4px;
        }
      }
    }

    .login-btn {
      width: 100%;
      height: 48px;
      border-radius: 24px;
      margin-top: 16px;
    }

    .check-rule {
      text-align: center;
      margin-top: 16px;

      ::v-deep .text {
        font-weight: 400;
        font-size: 12px;
        color: #8e8e8e;

        span {
          color: rgba(207, 15, 15, 1);
        }
      }

      ::v-deep .el-checkbox__inner {
        border-radius: 50%;
        width: 20px;
        height: 20px;

        &::after {
          left: 7px;
          top: 4px;
        }
      }
    }

    .wx-line {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 16px;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
      }

      span {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        margin-left: 8px;
      }
    }
  }
}

.preview-box {
  display: flex;
  padding: 24px 0px 56px 0px;
  box-sizing: border-box;
  
  .preview-column {
    &:first-child {
      //flex: 736;
      margin-right: 32px;
    }

    &:last-child {
      //flex: 352;
    }

    .mod-box {
      &:not(:first-child) {
        margin-top: 40px;
      }
    }
  }
}

.mod-title {
  height: 40px;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;

  span {
    display: inline-block;
  }

  > span {
    font-weight: bold;
    height: 40px;
    line-height: 40px;
    position: relative;

    span {
      color: rgba(207, 15, 15, 1);
    }

    &::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 2px;
      background: #cf0f0f;
      left: 0px;
      bottom: 0px;
    }
  }
}

.mod-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 35%, #ffffff 80%);
  padding-bottom: 16px;
  cursor: pointer;

  .red-text {
    font-weight: bold;
    color: #cf0f0f;
  }

  .grey-text {
    color: rgba(142, 142, 142, 1);
    font-size: 14px;
    margin-top: 8px;
  }
}

.ctx-wrap {
  position: relative;

  &.auto {
    height: initial !important;
  }

  .list-wrap {
    height: 100%;
  }
}

.box1 {
  .ctx-wrap {
    // height: 350px;
    overflow: hidden;
  }

  .list-wrap {
  }

  .study-item {
    padding: 0px 16px;
    box-sizing: border-box;
    margin-top: 16px;
    // width: 50%;

    .desc-box {
      display: flex;
      align-items: flex-end;
      height: 120px;
      position: relative;

      img {
        width: 90px;
        height: 120px;
        object-fit: cover;
        margin-right: 16px;
      }

      .text {
        flex: 1;
        position: relative;

        .main-text {
          font-weight: 500;
          font-size: 16px;
          color: #000000;
        }

        .sub-text {
          font-size: 14px;
          color: rgba(#000000, 0.5);
        }
      }
    }

    .article-list {
      margin-top: 16px;
      height: 78px;

      li {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:not(:first-child) {
          margin-top: 8px;
        }

        .title {
          font-size: 14px;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .status {
          font-size: 14px;
          color: #cf0f0f;
        }
      }
    }
  }
}

.box2 {
  .ctx-wrap {
    // height: 502px;
    // overflow: hidden;
  }

  .qa-list {
    margin-top: 24px;

    .qa-item {
      &:not(:first-child) {
        margin-top: 40px;
      }

      .qa-question {
        position: relative;
        background: linear-gradient(90deg, #ffe8e8 0%, rgba(255, 232, 232, 0) 100%);
        border-radius: 8px;
        display: flex;
        align-items: center;
        padding: 16px 13px;

        img {
          width: 48px;
          height: 48px;
          border-radius: 10px;
        }

        .val {
          font-weight: bold;
          font-size: 14px;
          line-height: 20px;
          margin-left: 13px;
        }
      }

      .qa-answer {
        display: flex;
        padding: 0px 13px;
        margin-top: 32px;
        .val {
          ::v-deep img {
            width: 100px;
            cursor: pointer;
          }
        }

        img {
          width: 48px;
          height: 48px;
          border-radius: 10px;
        }

        .val {
          margin-left: 13px;
          font-size: 14px;
        }
      }
    }
  }
}

.box3 {
  .ctx-wrap {
    // height: 350px;
    overflow: hidden;
  }

  .course-list {
    padding: 0px 16px;
  }

  .course-item {
    display: flex;
    align-items: center;
    padding: 16px 0px;
    box-sizing: border-box;

    &:not(:last-child) {
      border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
    }

    img {
      width: 120px;
      height: 90px;
      object-fit: cover;
      border-radius: 4px;
      border: 0.5px solid rgba(0, 0, 0, 0.1);
      margin-right: 16px;
    }

    .info-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // height: 90px;

      .title {
        font-weight: 500;
        color: #000000;
      }

      .sub-title {
        font-size: 14px;
        color: rgba(#000000, 0.5);
      }

      .count {
        font-size: 12px;
        color: rgba(#000000, 0.5);

        .tiao {
        }

        .status {
        }
      }
    }
  }
}

.box4 {
  .ctx-wrap {
    // height: 462px;
    overflow: hidden;
  }

  .chatroom-list {
    padding: 0px 16px;
  }

  .chatroom-item {
    padding: 16px 0px;
    box-sizing: border-box;

    &:not(:last-child) {
      border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
    }

    .top-wrap {
      display: flex;
      align-items: center;

      img {
        width: 48px;
        height: 48px;
        object-fit: cover;
        margin-right: 16px;
      }

      .info-wrap {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .name {
          font-weight: 500;
          line-height: 20px;
          margin-bottom: 5px;
        }

        .join-btn {
          width: 100px;
          height: 24px;
          line-height: 22px;
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #cf0f0f;
          font-weight: 500;
          font-size: 14px;
          color: #cf0f0f;
          text-align: center;
          cursor: pointer;
        }
      }
    }

    .desc {
      font-size: 14px;
      color: rgba(#000000, 0.5);
      margin-top: 10px;
    }
  }
}
</style>
<style lang="scss">
.invite-dialog {
  height: 354px;
  border-radius: 16px !important;

  .el-dialog__header {
    padding: 0px;

    .el-dialog__headerbtn {
      width: 24px;
      height: 24px;
      background: rgba(0, 0, 0, 0.05);
      border-radius: 12px;
      right: 0px;
      top: -32px;
    }
  }

  .el-dialog__body {
    padding: 24px !important;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: url("~@/assets/images/invite-code-cover.png") no-repeat center top;
    background-size: 100% auto;

    .top-wrap {
      display: flex;
      margin-top: 20px;

      img {
        width: 36px;
        height: 36px;
        margin-right: 8px;
      }

      .text-wrap {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 36px;

        .name {
          font-weight: bold;
          font-size: 16px;
          color: #000000;
          line-height: 16px;
          font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
        }

        .name2 {
          font-weight: 400;
          font-size: 12px;
          color: rgba(#000000, 0.5);
          font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
        }
      }
    }

    .name3 {
      display: flex;
      flex-direction: column;
      font-weight: bold;
      font-size: 16px;
      color: #000000;
      line-height: 24px;
      margin-top: 3px;
      font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    }

    .name4 {
      font-weight: 400;
      font-size: 14px;
      color: rgba(#000000, 0.5);
      font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
      span {
        position: relative;

        &::before {
          content: "·";
          color: #cf0f0f;
        }
      }
    }

    input {
      width: 304px;
      height: 48px;
      background: #f1f2f5;
      border-radius: 4px;
      outline: none;
      border: none;
      padding: 0px 16px;
      box-sizing: border-box;
      // margin-top: 32px;
    }

    .login-btn {
      height: 48px;
      border-radius: 24px;
    }

    .contact-btn {
      font-weight: 400;
      font-size: 14px;
      color: rgba(#000000, 0.5);
      display: inline-block;
      margin: 0px auto;
      cursor: pointer;
    }

    .qrcode-box {
      width: 150px;
      height: 150px;
      border-radius: 4px;
      border: 0.5px solid rgba(0, 0, 0, 0.1);
      position: relative;
      margin: 0px auto;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .hint {
      font-weight: 400;
      font-size: 12px;
      color: rgba(#000000, 0.5);
      display: inline-block;
      margin: 0px auto;
    }
  }
}
</style>
<style lang="scss" scoped>
.pb-dialog {
  border-radius: 16px !important;

  .hint {
    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 6px;
  }
  .hint-span {
    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(#000000, 0.5);
    line-height: 12px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .input-phone {
    height: 48px;
    background: #f1f2f5;
    margin-top: 24px;
    border-radius: 4px;

    ::v-deep .el-input-group__prepend {
      font-weight: 400;
      font-size: 16px;
      color: #000000;
      background: #f1f2f5;
      border: none;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 27px;
        right: 0px;
        background: rgba(0, 0, 0, 0.2);
      }
    }

    ::v-deep input {
      height: 100%;
      background: #f1f2f5;
      border: none;
    }
  }

  .input-vcode {
    height: 48px;
    background: #f1f2f5;
    margin-top: 16px;
    border-radius: 4px;

    ::v-deep input {
      height: 100%;
      background: #f1f2f5;
      border: none;
    }

    ::v-deep .el-input-group__append {
      background: #f1f2f5;
      border: none;
    }
  }

  .check-line {
    margin-top: 16px;

    ::v-deep .el-checkbox__label {
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.4);
    }

    ::v-deep .el-checkbox__inner {
      border-radius: 50%;
      width: 20px;
      height: 20px;
      border-radius: 4px;

      &::after {
        left: 7px;
        top: 4px;
      }
    }
  }

  .login-btn {
    width: 100%;
    height: 48px;
    border-radius: 24px;
    margin-top: 16px;
  }

  .check-rule {
    text-align: center;
    margin-top: 16px;

    ::v-deep .text {
      font-weight: 400;
      font-size: 12px;
      color: #8e8e8e;

      span {
        color: rgba(207, 15, 15, 1);
      }
    }

    ::v-deep .el-checkbox__inner {
      border-radius: 50%;
      width: 20px;
      height: 20px;

      &::after {
        left: 7px;
        top: 4px;
      }
    }
  }

  .wx-line {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
    }

    span {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      margin-left: 8px;
    }
  }
}
</style>
<style lang="scss">
.pb-dialog {
  border-radius: 16px !important;
  .el-dialog__header {
    padding: 0px;
  }
}

.el-carousel__indicators--horizontal {
  display: none;
}
</style>
<style lang="scss" scoped>
.admin {
  text-align: center;
  padding-bottom: 25px;
  padding-top: 10px;

  .line1 {
    display: flex;
    justify-content: center;

    img {
      width: 24px;
      margin-right: 8px;
    }
    div {
      font-weight: bold;
      font-size: 16px;
      color: #000000;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }

  .line2 {
    font-size: 20px;
    color: #000000;
    line-height: 20px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 12px;
  }
  .line3 {
    width: 150px;
    height: 150px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    margin-top: 24px;

    img {
      width: 150px;
      // margin: 2px auto;
    }
  }
}

.h-course,
.h-study {
  max-height: 350px;
}
.h-chat {
  max-height: 460px;
}

.ai-banner-wrapper {
  width: 1120px;
  margin: 24px auto 0;
  cursor: pointer;
  
  .ai-banner-content {
    height: 48px;
    background: url("~@/assets/images/RectangleAi.png") no-repeat center center;
    background-size: 100% 100%;
    border-radius: 16px;
    display: flex;
    align-items: center;
    padding: 3px ;
    box-shadow: 0 4px 12px rgba(207, 15, 15, 0.2);
    
    .ai-btn {
      height: 48px;
      background: #fff;
      border-radius: 16px;
      display: flex;
      align-items: center;
      padding: 0 24px;
      color: #cf0f0f;
      font-weight: bold;
      font-size: 18px;
      margin-right: 24px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.1);
      
      i {
        margin-left: 8px;
        font-weight: bold;
      }
    }
    
    .ai-desc {
      color: #fff;
      font-size: 18px;
      font-weight: 500;
      text-shadow: 0 1px 2px rgba(0,0,0,0.1);
    }
  }
}
</style>
